import React from "react"
import { Link } from "react-router-dom"
import { useCart } from "react-use-cart"

const Cart = ({ closeCart }) => {
  const { items, updateItemQuantity, removeItem, cartTotal, isEmpty, getItem } =
    useCart()

  return (
    <div
      style={{ width: "900px", maxWidth: "900px" }}
      className="bg-white shadow-md rounded pb-12 p-6"
    >
      <div className="flex justify-between">
        <h3 className="sabi-header text-2xl">Your Cart</h3>
        <div className="hidden mobiles:block">
          <p className="text-gray-500">Cart Items</p>
          <span className="mt-2 w-10 rounded-full ml-auto h-10 flex justify-center items-center text-white bg-blue-500">
            2
          </span>
        </div>
        <Link
          to="/checkout"
          className=" py-2 px-6 mobiles:px-3 bg-sbg-light-green border border-transparent text-transparent rounded-md text-base text-white mobiles:hidden "
        >
          Checkout Now
        </Link>
      </div>
      <div className="mt-10 max-h-96 overflow-auto">
        {isEmpty && <h3 className="text-center text-xl">Your cart is empty</h3>}
        {items.map(item => (
          <div className="flex mobiles:block border pr-3  mobiles:px-3 mt-8 border-gray-200 rounded items-center">
            <div className="flex items-center mobiles:pt-6">
              <img
                src={item.images[0]}
                alt=""
                className="block w-56 mobiles:w-20 mobiles:self-start mr-3 object-center h-full"
              />
              <div className="w-60 text-xs mr-8">
                <p className="font-semibold">{item.name}</p>
                <p className="text-red-500 mt-3">₦{`${item.sales_price}`}</p>
                <p className="text-green-500 mt-3">In Stock</p>
                <p className="text-gray-600 mt-5 mobiles:hidden">{item.sku}</p>
              </div>
            </div>

            <div className="p-6 border mobiles:border-0 mobiles:py-5 mobiles:mt-6 mobiles:rounded-none mobiles:border-t-2 border-gray-200 rounded items-center flex-1 flex justify-between">
              <p className="mobiles:order-3">
                ₦{item.quantity * item.sales_price}
              </p>
              <div className="w-24 px-1 mobiles:order-2 flex justify-between border border-gray-200 items-center h-10">
                <span
                  className="w-6 h-6 flex justify-center items-center text-xl text-white bg-gray-300 rounded-full cursor-pointer"
                  onClick={() => updateItemQuantity(item.id, item.quantity - 1)}
                >
                  -
                </span>
                <p>{`${item.quantity}`}</p>
                <span
                  className="w-6 h-6 flex justify-center items-center text-xl text-white bg-green-300 rounded-full cursor-pointer"
                  onClick={() => {
                    if (getItem(item.id)) {
                      const { quantity, inStock } = getItem(item.id)

                      if (quantity >= inStock) {
                        updateItemQuantity(item.id, inStock)
                      } else {
                        updateItemQuantity(item.id, item.quantity + 1)
                      }
                    }
                  }}
                >
                  +
                </span>
              </div>
              <img
                src={require("../../assets/delete-icon.svg").default}
                alt=""
                className="w-6 mobiles:order-1 cursor-pointer"
                onClick={() => removeItem(item.id)}
              />
            </div>
          </div>
        ))}
      </div>

      <div className="mt-10 pt-4 hidden mobiles:block border-t-2 border-gray-200">
        <p className="text-gray-700">Have a voucher?</p>
      </div>
      <div className="mt-4 hidden mobiles:block pt-4 border-t-2 border-gray-200">
        <div className="flex mb-3 items-center justify-between">
          <p className="text-gray-600">Subtotal</p>
          <p className="text-gray-600">₦ {`${cartTotal}`}</p>
        </div>
        <div className="flex mb-3 items-center justify-between">
          <p className="text-gray-600">Shipping</p>
          <p className="text-gray-600">free</p>
        </div>
      </div>
      <div className="mt-4 hidden mobiles:block pt-4 border-t-2 border-gray-200">
        <div className="flex mb-3 items-center justify-between">
          <p className="text-gray-600 font-semibold">Total</p>
          <p className="text-gray-600 font-semibold">₦ {`${cartTotal}`}</p>
        </div>
      </div>

      <div className="flex mobiles:flex-col mt-8 mobiles:pr-0 justify-end items-center pr-4">
        <h3
          className="text-lg mobiles:order-2 mobiles:mt-3 text-gray-600 mobiles:flex mobiles:items-center mobiles:text-base mr-4 cursor-pointer"
          onClick={() => closeCart()}
        >
          <img
            src={require("../../assets/back-arrow.svg").default}
            alt=""
            className="w-3 mr-3  inline-block "
          />
          continue shopping
        </h3>
        <Link
          to="/checkout"
          className=" py-2 px-6 mobiles:order-1 mobiles:w-full  mobiles:px-3 bg-sbg-light-green border border-transparent text-transparent rounded-md text-base text-white "
        >
          Checkout Now
        </Link>
      </div>
    </div>
  )
}

export default Cart
